/* eslint-disable prettier/prettier */
import VideoComment from '@/components/VideoComment';
import FillCommentUserInfo from '@/components/VideoComment/FillCommentUserInfoModal';
import { useVideoCommentInfoModal } from '@/containers/ProjectDetail/components/OrderContent/OutputTab/VideoCommentInfoModalProvider';
import useCurrentId from '@/containers/ProjectDetail/hooks/useCurrentId';
import useGetCurrentAllMaterials from '@/containers/ProjectDetail/hooks/useGetCurrentAllMaterials';
import useGetProjectDetail from '@/containers/ProjectDetail/services/useGetProjectDetail';
import { tPrefix } from '@/utils/const';
import useShowVideoCommentBySearchParam from '@/utils/hooks/useShowVideoCommentBySearchParam';
import { useTeaEvent, withPage } from '@/utils/logger/event-tracking';
import { Modules, PageEnum } from '@/utils/logger/event-tracking/types';
import { observer } from 'mobx-react';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useAssetSharingMetaData } from './hooks';
import styles from './index.module.scss';
import { VideoPreviewCard } from '@/containers/ProjectDetail/components/DeliverablePreviewCard/VideoPreviewCard';
import { TrackPointEntitySubCategory } from '@/containers/BusinessRelatedParams/consts';

const SharePage = () => {
  const { t } = useTranslation();
  const segment = location.pathname.split('/') ?? [];
  const shareToken = segment.pop() ?? '';
  const { data: sharingMetaData } = useAssetSharingMetaData(shareToken);
  const { expose } = useTeaEvent();
  const { showCommentInfoModal, setShowCommentInfoModal } = useVideoCommentInfoModal();
  const [_, setSearchParams] = useSearchParams();
  const { projectId: currentProjectId } = useCurrentId();
  const { data } = useGetCurrentAllMaterials();

  const projectId = sharingMetaData?.orderId || currentProjectId;

  useEffect(() => {
    if (projectId) {
      expose(Modules.order_flow_share_page.self, {
        order_id: projectId
      });
    }
  }, [projectId]);

  const showVideoComment = useShowVideoCommentBySearchParam();

  // 如果是登录用户就获取订单详情，获取成功表示有权限，直接调到订单详情页
  useGetProjectDetail(projectId, {
    onSuccess: (result) => {
      if (result) {
        location.href = `https://ads.tiktok.com/creativeexchange/service-provider/project/detail?orderId=${projectId}`;
      }
    }
  });

  function openComment(index: number) {
    setSearchParams((params) => {
      params.set('materialId', data?.projectVideos[index]?.materialId ?? '');
      return params;
    });
  }

  return (
    <div className={styles.sharing}>
      <div className={styles.body}>
        <div className={styles.header}>
          <div className={styles.title}>
            {t(
              sharingMetaData?.totalAssetNumber === 1
                ? tPrefix.OF(`shared_page_title`)
                : tPrefix.OF(`shared_page_title_plural`),
              `${
                sharingMetaData?.totalAssetNumber === 1
                  ? `{{count}} item shared by {{name}}`
                  : `{{count}} items shared by {{name}}`
              }`,
              {
                count: String(sharingMetaData?.totalAssetNumber) as any,
                name: String(sharingMetaData?.shareName)
              }
            )}

            <div className={styles.time}>
              <span>{moment.unix(sharingMetaData?.createdAt!).format('YYYY-MM-DD HH:mm:ss')}</span>
            </div>
          </div>
        </div>
        <div className={styles.content}>
          {data?.projectVideos.map((item, index) => (
            <div key={item.fileUid} className="w-[234px]">
              <VideoPreviewCard
                className={styles.card}
                key={item.fileUid}
                onShowComment={() => openComment(index)}
                {...item}
              />
            </div>
          ))}
        </div>
      </div>

      {showVideoComment && <VideoComment />}

      <FillCommentUserInfo show={showCommentInfoModal} onChange={setShowCommentInfoModal} />
    </div>
  );
};

export default withPage(observer(SharePage), PageEnum.OrderFlowSharePage);
